<mat-card class="crud-search-card">
  <mat-card-title i18n="@@type.Contract.pendingTransferAsset.Approval">Transfer Assets Pending  Approval</mat-card-title>
  <mat-card-content>
<div class="mat-elevation-z8">
    <div class="mat-table-wrapper">
      <mat-table #table [dataSource]="dataSource" matSort
                         matSortDirection="asc" matSortDisableClear cdkDropList cdkDropListLockAxis="x"
                         cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" Group>

        <ng-container matColumnDef="description">
          <mat-header-cell [crud-column-header]="columns.column('description')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.Asset.description">
              Description 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.asset.description}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="sourceBusinessUnit.buId">
          <mat-header-cell [crud-column-header]="columns.column('sourceBusinessUnit.buId')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.source.businessUnit">
              Source Business Unit 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.asset.businessUnit?.buId}} - {{element.asset.businessUnit?.name}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="sourceCostCentre.ccId">
          <mat-header-cell [crud-column-header]="columns.column('sourceCostCentre.ccId')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.source.costCentre">
            Source Cost Centre 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.asset.costCentre?.ccId}} - {{element.asset.costCentre?.name}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="targetBusinessUnit.buId">
          <mat-header-cell [crud-column-header]="columns.column('targetBusinessUnit.buId')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.businessUnit">
              Target Business Unit 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.businessUnit?.buId}} - {{element.businessUnit?.name}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="targetCostCentre.ccId">
          <mat-header-cell [crud-column-header]="columns.column('targetCostCentre.ccId')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.costCentre">
             Target Cost Centre 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.costCentre?.ccId}} - {{element.costCentre?.name}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="approvalRejectionComment">
          <mat-header-cell [crud-column-header]="columns.column('approvalRejectionComment')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.approvalRejectionComment">
              Approval Rejection Comment 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.approvalRejectionComment}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="approved">
          <mat-header-cell [crud-column-header]="columns.column('approved')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.approved">
              Approved 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.approved}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="approvedRejectedBy">
          <mat-header-cell [crud-column-header]="columns.column('approvedRejectedBy')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.approvedRejectedBy">
              Approved Rejected By 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.approvedRejectedBy}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="approvedRejectedDate">
          <mat-header-cell [crud-column-header]="columns.column('approvedRejectedDate')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.approvedRejectedDate">
              Approved Rejected Date 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.approvedRejectedDate | uimDateFormat}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="comments">
          <mat-header-cell [crud-column-header]="columns.column('comments')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.comments">
              Comments 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.comments}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="createdBy">
          <mat-header-cell [crud-column-header]="columns.column('createdBy')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.createdBy">
              Created By 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.createdBy}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="dateCreated">
          <mat-header-cell [crud-column-header]="columns.column('dateCreated')" *matHeaderCellDef 
            mat-sort-header cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.dateCreated">
              Date Created 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            {{element.dateCreated | uimDateFormat}}
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="pendingApproval">
          <mat-header-cell [crud-column-header]="columns.column('pendingApproval')" *matHeaderCellDef 
            cdkDropList cdkDropListLockAxis="x"
            cdkDropListOrientation="horizontal" (cdkDropListDropped)="columns.dropListDropped($event)" cdkDrag
            class="search-column-small" i18n="@@type.TransferAsset.pendingApproval">
              Pending Approval 
            </mat-header-cell>
          <mat-cell class="search-column-small" *matCellDef="let element">
            <mat-icon *ngIf="element.pendingApproval">check_box</mat-icon><mat-icon *ngIf="!element.pendingApproval">check_box_outline_blank</mat-icon>
          </mat-cell>
        </ng-container>  

        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell class="search-column-actions mat-elevation-z9" *matHeaderCellDef>
            <span i18n="@@common.actions">Actions</span>
            <app-column-picker-dialog-launcher [columns]="columns">
            </app-column-picker-dialog-launcher>
          </mat-header-cell>
          <span>
            <mat-cell *matCellDef="let element"
              class="search-column-kindasmall search-column-actions mat-elevation-z9">
              <div *ngIf="allowsApproval(element)">
                <button class="action-button" mat-raised-button color="primary" [routerLink]="editRoute(element)"
                  [queryParams]="editRouteQueryParams()" i18n="@@actions.approveOrReject" id="actions.approve">
                  Approve/Reject </button>
              </div>

              <div *ngIf="!allowsApproval(element)">
                <button class="action-button" mat-raised-button color="primary" [routerLink]="viewRoute(element)"
                  [queryParams]="editRouteQueryParams()" i18n="@@actions.view" id="actions.view">View</button>
                <span *ngIf="currentUserIsCreator(element)"><button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent"
                (click)="deleteWithConfirmation(element)" i18n="@@actions.delete" id="actions.delete">Delete</button>
                <button class="action-button" *ngIf="allowsDelete(element)" mat-raised-button color="accent2"
                (click)="openEmailReminder(element)" i18n="@@actions.email" id="actions.email">Email</button>
              </span>
              </div>
            </mat-cell>
          </span>
          <mat-footer-cell class="search-column-kindasmall search-column-actions" *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columns.displayedColumns" class="search-table"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columns.displayedColumns;" class="search-table"></mat-row>

      </mat-table>
    </div>
    <mat-paginator [length]="pageInfo.totalElements" [pageSize]="pageInfo.size" [pageSizeOptions]="pageSizes">
    </mat-paginator>
  </div>
</mat-card-content>
</mat-card>